import { graphql, useStaticQuery } from 'gatsby';
import { Authors } from '@contracts';

export const query = graphql`
  query getContributors {
    allPrismicVitalsAuthors {
      nodes {
        id
        uid
        url
        data {
          meta_description
          meta_title
          meta_image {
            url
          }
          name
          title
          professional_title
          author_bio {
            text
            richText
          }
          image {
            alt
            gatsbyImageData
            url
          }
          tags {
            tag
          }
          can_book_consultations
        }
      }
    }
  }
`;

export const getAuthors = () => {
  const { allPrismicVitalsAuthors } = useStaticQuery(query);
  const { nodes } = allPrismicVitalsAuthors as Authors;
  return [...nodes];
};
